/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfileAvailability
 */
export interface ProfileAvailability {
    /**
     * 
     * @type {string}
     * @memberof ProfileAvailability
     */
    value: ProfileAvailabilityValueEnum;
    /**
     * 
     * @type {string}
     * @memberof ProfileAvailability
     */
    frequency?: ProfileAvailabilityFrequencyEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileAvailability
     */
    partial: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ProfileAvailability
     */
    nextAvailabilityDate?: Date;
}


/**
 * @export
 */
export const ProfileAvailabilityValueEnum = {
    AvailableAndVerified: 'AVAILABLE_AND_VERIFIED',
    Available: 'AVAILABLE',
    AvailableSoon: 'AVAILABLE_SOON',
    NotAvailableWithDate: 'NOT_AVAILABLE_WITH_DATE',
    NotAvailable: 'NOT_AVAILABLE'
} as const;
export type ProfileAvailabilityValueEnum = typeof ProfileAvailabilityValueEnum[keyof typeof ProfileAvailabilityValueEnum];

/**
 * @export
 */
export const ProfileAvailabilityFrequencyEnum = {
    OneDayPerWeek: 'ONE_DAY_PER_WEEK',
    TwoDaysPerWeek: 'TWO_DAYS_PER_WEEK',
    ThreeDaysPerWeek: 'THREE_DAYS_PER_WEEK',
    FourDaysPerWeek: 'FOUR_DAYS_PER_WEEK',
    EveningsAndWeekends: 'EVENINGS_AND_WEEKENDS',
    FullTime: 'FULL_TIME'
} as const;
export type ProfileAvailabilityFrequencyEnum = typeof ProfileAvailabilityFrequencyEnum[keyof typeof ProfileAvailabilityFrequencyEnum];


/**
 * Check if a given object implements the ProfileAvailability interface.
 */
export function instanceOfProfileAvailability(value: object): value is ProfileAvailability {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('partial' in value) || value['partial'] === undefined) return false;
    return true;
}

export function ProfileAvailabilityFromJSON(json: any): ProfileAvailability {
    return ProfileAvailabilityFromJSONTyped(json, false);
}

export function ProfileAvailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileAvailability {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'frequency': json['frequency'] == null ? undefined : json['frequency'],
        'partial': json['partial'],
        'nextAvailabilityDate': json['nextAvailabilityDate'] == null ? undefined : (new Date(json['nextAvailabilityDate'])),
    };
}

export function ProfileAvailabilityToJSON(value?: ProfileAvailability | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'frequency': value['frequency'],
        'partial': value['partial'],
        'nextAvailabilityDate': value['nextAvailabilityDate'] == null ? undefined : ((value['nextAvailabilityDate']).toISOString().substring(0,10)),
    };
}

